import React, {useState} from 'react'
import SuspectCard from './SuspectCard'
import suspectData from './suspectData'
import KeyMatch from "./KeyMatch"
import LockPick from "./LockPick"
import LockPickReward from "./LockPickReward"

function PartOne(props) {
    const [suspects] = useState(suspectData)
    const [puzzleCompleted, setPuzzleCompleted] = useState({
        keyMatch: false,
        lockPick: false
    })
    
    if (props.partStatus === "complete" && !puzzleCompleted.keyMatch) {
        setPuzzleCompleted({
            keyMatch: true,
            lockPick: true
        })
    }
    
    function puzzleUpdate(puzzle) {
        setPuzzleCompleted({
            ...puzzleCompleted,
            [puzzle]: true
        })
        
        if (puzzle === "keyMatch") {props.callBackRevealClues("Picking The Lock", "Matching The Key")}
        if (puzzle === "lockPick") {props.callBackRevealClues("undefined", "Picking The Lock")}
    }
    
    let mainPuzzle
    if (puzzleCompleted.lockPick) {
        mainPuzzle = <LockPickReward />
    } else if (puzzleCompleted.keyMatch) {
        mainPuzzle = <LockPick callBackPuzzleUpdate={puzzleUpdate} callBackKeypad={props.callBackKeypad} callBackOverlay={props.callBackOverlay}/>
    } else {
        mainPuzzle = <KeyMatch callBackPuzzleUpdate={puzzleUpdate} callBackOverlay={props.callBackOverlay}/>
    }
    
    const suspectCards = suspects.map(suspect => {
        return <SuspectCard key={suspect.id} name={suspect.name} description={suspect.description} imageSource={suspect.image}/>
    })
                                      
    return (
        <div>
            <h3> The museum had been closed on the day the diamond disappeared and only 7 people were reported to have visited the building. Until I can be certain of who to trust, I am treating them all as suspects: </h3>
            {suspectCards}
            <div className={"colourStripe greenTab"} />
            {mainPuzzle}
        </div>
    )
}

export default PartOne